import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getContacts } from "@store/action/smartend/ContactAction";
import { useTranslation } from "react-i18next";
import BreadCrumbs from "@components/breadcrumbs/index1";

const ContactUs = () => {
  const dispatch = useDispatch();
  const ContactReducer = useSelector((state) => state.ContactReducer);
  const contact = ContactReducer.data.data;
  useEffect(() => {
    dispatch(getContacts());
  }, []);
  const { t } = useTranslation();
  const RadioReducer = useSelector((state) => state.RadioReducer);
  const latitude = RadioReducer.single?.latitude;
  const longitude = RadioReducer.single?.longitude;

  return (
    <div>
      <BreadCrumbs breadCrumbTitle={t("Contact us")} />
      <div className="contact_icon_section ms_cover">
        <div className="container" style={{ maxWidth: "90%" }}>
          <div className="row">
            <div className="col-lg-10 offset-lg-1 col-md-12 col-sm-12">
              <div className="ms_heading_wrapper ms_cover text-center">
                <h1>contact with us</h1>
                <p>Your next level Product developemnt company assets</p>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-12">
              <div className="contact_main ms_cover">
                <div className="contact_rotate">
                  <i className="fas fa-phone" />
                </div>
                <h4>{t("Contact us")}</h4>

                <p>
                  {t("Mobile")}: {contact?.mobile}
                  {/* <br /> {t("Mobile")}: {contact?.mobile} */}
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-12">
              <div className="contact_main ms_cover">
                <div className="contact_rotate">
                  <i className="fas fa-envelope" />
                </div>
                <h4>Email</h4>
                <p>
                  <a>{contact?.email}</a>
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-12">
              <div className="contact_main ms_cover">
                <div className="contact_rotate">
                  <i className="fas fa-map-marker-alt" />
                </div>
                <h4>{t("Find us")}</h4>
                <p>{contact?.address}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* contact info section end */}
      {/* ms map Start */}
      <div className="map_main_wrapper ms_cover">
        <div className="contact-map">
          <iframe
            src={`https://maps.google.com/maps?q=${latitude},${longitude}&output=embed`}
            width="100%"
            height="100%"
            frameBorder="0"
            style={{ border: "0" }}
            allowFullScreen="100%"
            aria-hidden="false"
            tabIndex="0"
          ></iframe>
        </div>
      </div>
      {/* ms map End */}
      {/* contact_wrapper start */}
      {/* <div className="contact_section ms_cover">
        <div className="container" style={{ maxWidth: "90%" }}>
          <div className="row">
            <div className="col-lg-10 offset-lg-1 col-md-12 col-sm-12">
              <div className="ms_heading_wrapper ms_cover text-center">
                <h1>GET IN TOUCH</h1>
                <p>Your next level Product developemnt company assets</p>
              </div>
            </div>
            <div className="col-lg-10 offset-lg-1 col-md-12 col-sm-12 col-12">
              <form>
                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    <div className="form-pos">
                      <div className="form-group i-name">
                        <input
                          type="text"
                          className="form-control require"
                          name="first_name"
                          required=""
                          placeholder="First Name*"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div className="form-pos">
                      <div className="form-group i-name">
                        <input
                          type="text"
                          className="form-control require"
                          name="last_name"
                          required=""
                          placeholder="last Name*"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div className="form-e">
                      <div className="form-group i-email">
                        <input
                          type="email"
                          className="form-control require"
                          name="email"
                          required=""
                          placeholder=" Email *"
                          data-valid="email"
                          data-error="Email should be valid."
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div className="form-s">
                      <div className="form-group i-subject">
                        <input
                          type="text"
                          className="form-control require"
                          name="Subject"
                          required=""
                          placeholder="subject"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-m">
                      <div className="form-group i-message">
                        <textarea
                          className="form-control require"
                          name="message"
                          required=""
                          rows={5}
                          id="messageTen"
                          placeholder=" Message"
                          defaultValue={""}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="tb_es_btn_div">
                      <div className="response" />
                      <div className="tb_es_btn_wrapper">
                        <button type="button" className="submitForm">
                          <i className="flaticon-play-button" /> send !
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default ContactUs;
